import $ from 'jquery';
import Form from 'jquery-form';

class Registration {


    constructor() {
        var _self = this;
        $('document').ready(function (e) {
            _self.form = Form(document, $);
            _self.regForm = _self.form('.js-registration-form');
            _self.logForm = _self.form('.js-login-form');
            _self.forgottenPassword = _self.form('.js-forgotten-form');
            _self.regFormResults = _self.form('#reg-form-results');
            _self.initListener();

        });
    }

    initListener() {
        this.showLoaderEvent = new Event('loader.show');

        this.regForm.ajaxForm((response) => {
            document.dispatchEvent(this.showLoaderEvent);
            if (response === 'OK') {
                window.location.reload();
                window.location.replace(window.location.origin + '/checkout');
            } else {
                try {
                    response = JSON.parse(response);
                    if (response.errors && response.errors.length) {
                        this.parseErrors(response);
                    }
                } catch (e) {
                }
            }
        });
        this.logForm.ajaxForm((response) => {
            document.dispatchEvent(this.showLoaderEvent);
            if (response === 'OK') {
                window.location.reload();
            } else {
                try {
                    response = JSON.parse(response);
                    if (response.errors && response.errors.length) {
                        this.parseErrors(response);
                    }
                } catch (e) {

                }
            }
        });

        this.forgottenPassword.ajaxForm((response) => {
            this.forgottenPassword.html('<p> Please check your email</p>');
        })
    }

    parseErrors(response) {

        let results = '';
        for (let res in response.errors) {
            results += '<p>' + response.errors[res] + '</p>'
        }
        this.regFormResults.html(results);
    }


}

export default Registration;